import { type Conversation } from "shared/apiClient";
import { getText, type Noticeboard } from "shared/lib";

import { MissingInformationReport } from "shared/components";

export interface MissingInformationProps {
  conversation: Conversation | undefined | null;
  messages: Conversation["messages"];
  noticeboardData: Noticeboard | undefined | null;
  printable?: boolean;
}

export function MissingInformation({
  conversation,
  noticeboardData,
  printable,
}: MissingInformationProps) {
  return (
    <div className="flex flex-col gap-10">
      <h2 className="text-textPrimary text-heading2xl">
        {getText("Missing information")}
      </h2>

      <MissingInformationReport
        conversation={conversation}
        noticeboardData={noticeboardData}
        printable={printable}
        configPrefix="enquiry"
      />
    </div>
  );
}
